import React from "react";
import styles from "./spinner-with-variant.module.scss";

const cssClassName = "spinner-with-variant";

type SpinnerProps = {
  variant?: string | string[];
};

const SpinnerWithVariant: React.FC<SpinnerProps> = ({ variant = "small" }) => {
  let variantClass = "";

  if (typeof variant === "string") {
    variantClass = styles[`${cssClassName}--${variant}`];
  } else if (Array.isArray(variant)) {
    variantClass = variant
      .map((v) => styles[`${cssClassName}--${v}`])
      .join(" ");
  }

  return (
    <div className={`${styles[cssClassName]} ${variantClass}`}>
      <svg
        className="MuiCircularProgress-svg css-1idz92c-MuiCircularProgress-svg"
        viewBox="22 22 44 44"
      >
        <circle
          className="MuiCircularProgress-circle MuiCircularProgress-circleIndeterminate MuiCircularProgress-circleDisableShrink css-79nvmn-MuiCircularProgress-circle"
          cx="44"
          cy="44"
          r="20.2"
          fill="none"
          stroke="currentColor"
          strokeWidth="3.6"
          strokeDasharray="126.68"
          strokeDashoffset="37.9"
        ></circle>
      </svg>
    </div>
  );
};

export default SpinnerWithVariant;
